// crewTokens.js — Desert Flora design tokens for the Crew Dashboard (canonical source).
export const T = {
  bg: '#f4efe4', surface: '#fbf8f1', surface2: '#f6f1e3', surface3: '#ece5d3',
  line: '#e0d8c2', line2: '#cec3a5', lineSoft: '#ede6d2',
  ink: '#1c2419', ink2: '#3d463a', mute: '#6f7a6b', muteSoft: '#97a094',
  green: '#1f5e3a', greenDeep: '#164a2c', greenSoft: '#e3eee0', greenSofter: '#eef5eb',
  rust: '#a9341d', rustSoft: '#f7dccf',
  orange: '#c66a45', orangeSoft: '#fdf0e8',
  warn: '#b35d1a', warnSoft: '#fbe8d6',
  plum: '#6e3fb7', plumSoft: '#efe8f9',
  amber: '#a87320', amberSoft: '#f7ecd8',
  blue: '#3454c1', blueSoft: '#e2e8f7',
  mono: "'JetBrains Mono', ui-monospace, Menlo, monospace",
};

export const CLOCK = {
  onsite: { c: T.green, soft: T.greenSoft, label: 'On site' },
  driving: { c: T.orange, soft: T.orangeSoft, label: 'Driving' },
  lunch: { c: T.amber, soft: T.amberSoft, label: 'Lunch' },
  break: { c: T.blue, soft: T.blueSoft, label: 'Break' },
  off: { c: T.muteSoft, soft: T.surface3, label: 'Clocked out' },
  // Phase 2.1: 'unknown' = no shift data available (Aspire-stale crews); MUST NOT read 'Clocked out' (false).
  unknown: { c: T.muteSoft, soft: T.surface3, label: 'No clock data' },
};

export const BUDGET_CATS = [
  { k: 'onsite', label: 'On-site', c: T.green },
  { k: 'driving', label: 'Driving', c: T.blue },
  { k: 'lunch', label: 'Lunch', c: T.amber },
  { k: 'break', label: 'Break', c: T.plum },
  { k: 'tracked', label: 'Tracked', c: T.orange },
  { k: 'idle', label: 'Idle', c: T.rust },
  { k: 'yard', label: 'Yard', c: T.muteSoft },
];
